import { useState } from "react";
import { useSite } from "@/context/SiteContext";
import { CONTACT_PRICE, formatDate, formatPrice } from "@/lib/api";

const Row = ({ t, cat }) => {
  const { openInquiry } = useSite();
  const price = formatPrice(t);
  return (
    <div className="flex items-start justify-between gap-3 py-4 border-b border-nanina-line last:border-0" data-testid={`price-row-${t.id}`}>
      <div className="min-w-0">
        <p className="text-sm font-semibold text-nanina-green flex flex-wrap items-center gap-1.5">
          {t.name}
          {t.kind === "package" && <span className="text-[10px] rounded-full bg-nanina-skysoft px-2 py-0.5">Paket</span>}
          {t.promo_label && <span className="text-[10px] rounded-full bg-nanina-butter/70 px-2 py-0.5">{t.promo_label}</span>}
        </p>
        {t.description && <p className="text-xs text-nanina-muted mt-0.5">{t.description}</p>}
        {t.note && <p className="text-[11px] text-[#8A6D3B] mt-1">Catatan: {t.note}</p>}
        <p className="text-[10px] text-nanina-muted/80 mt-1">Diperbarui {formatDate(t.updated_at)}</p>
      </div>
      <div className="text-right shrink-0 max-w-[45%]">
        <p className={`font-bold text-nanina-green ${price ? "text-sm" : "text-[11px] font-medium"}`} data-testid={`price-value-${t.id}`}>{price || CONTACT_PRICE}</p>
        <button onClick={() => openInquiry(`${cat.name} / ${t.name}`)} className="mt-2 rounded-full bg-nanina-freshsoft text-nanina-green text-[11px] font-semibold px-3 py-1.5 hover:bg-[#D9EFDE]" data-testid={`price-ask-${t.id}`}>Tanya</button>
      </div>
    </div>
  );
};

export const PriceList = () => {
  const { site } = useSite();
  const [filter, setFilter] = useState("all");
  const cats = site.categories.filter((c) => filter === "all" || c.id === filter);
  return (
    <section id="harga" className="py-12 sm:py-16 bg-[#F0F8F9] border-y border-nanina-line" data-testid="pricing-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 grid lg:grid-cols-[.7fr_1.3fr] gap-6 lg:gap-10 items-start">
        <div>
          <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-nanina-fresh">Daftar Harga</p>
          <h2 className="mt-1 text-2xl sm:text-3xl font-extrabold tracking-tight text-nanina-green">Tarif layanan yang dipublikasikan</h2>
          <p className="mt-3 text-sm text-nanina-muted">Tarif dapat berubah sewaktu-waktu. Untuk layanan tanpa tarif tercantum, silakan tanyakan langsung kepada admin.</p>
        </div>
        <div className="min-w-0 rounded-3xl bg-white border border-nanina-line p-4 sm:p-6 shadow-[0_12px_32px_rgba(43,94,85,0.08)]">
          <div className="flex gap-2 overflow-x-auto sm:flex-wrap nn-scroll-x pb-3 -mx-1 px-1" role="tablist" aria-label="Filter kategori harga">
            {[{ id: "all", name: "Semua" }, ...site.categories].map((c) => (
              <button key={c.id} role="tab" aria-selected={filter === c.id} onClick={() => setFilter(c.id)} className={`shrink-0 rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors ${filter === c.id ? "bg-nanina-green text-white" : "bg-nanina-bg text-nanina-green hover:bg-nanina-skysoft"}`} data-testid={`price-filter-${c.slug || "all"}`}>
                {c.name}
              </button>
            ))}
          </div>
          {cats.map((cat) => {
            const items = site.treatments.filter((t) => t.category_id === cat.id);
            return (
              <div key={cat.id} className="mt-3" data-testid={`price-group-${cat.slug}`}>
                <p className="text-xs font-bold uppercase tracking-wider text-nanina-muted">{cat.name}</p>
                {items.length ? items.map((t) => <Row key={t.id} t={t} cat={cat} />) : (
                  <p className="my-2 rounded-xl bg-nanina-bg px-4 py-3 text-xs text-nanina-muted" data-testid={`price-empty-${cat.slug}`}>{CONTACT_PRICE}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
